import { render, staticRenderFns } from "./SuccessPromo.vue?vue&type=template&id=b711b6cc&"
import script from "./SuccessPromo.vue?vue&type=script&lang=js&"
export * from "./SuccessPromo.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPromo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports